module.exports = __webpack_public_path__ + "static/testi-1-1-21bc06aa110baff7625b73e894d53bbe.jpg";